export const HelpWidgetError = () => null;
